import institutionAPI from 'services/institutionAPI'
import { JobsiteFilters } from 'InstitutionalManagement/types'

type Params = {
  filters: JobsiteFilters
}

export default async function readJobsitesOnCustomForm({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/citizen-portal/service/jobsites',
    data: filters,
  })

  return response
}
